import { TypeDeclaration, useGetOrganismeEtablissementsConsolidesCountQuery } from '@common/services';
import React from 'react';

const TYPE_DECLARATION_TEXTS: Record<TypeDeclaration, string> = {
  [TypeDeclaration.CONSOLIDEE]: 'Consolidée',
  [TypeDeclaration.INDIVIDUELLE]: 'Individuelle',
};

export const TypeDeclarationCell = ({ organismeId, typeDeclaration, principal }: TypeDeclarationCellProps) => {
  const { data: count = 1 } = useGetOrganismeEtablissementsConsolidesCountQuery({
    id: organismeId,
  }, { skip: !principal });

  return (
    <div className={'flex items-center gap-2'}>
      {(principal || typeDeclaration === TypeDeclaration.INDIVIDUELLE)
        ? (
          <div className={'bg-[#00008F] flex flex-col justify-center items-center align-middle rounded-full w-6 h-6'}>
            <span className={'text-white text-sm'}>{count}</span>
          </div>
        ) : (
          <div className={'w-6 h-6'} />
        )}

      <span>{TYPE_DECLARATION_TEXTS[typeDeclaration]}</span>
    </div>
  );
};

interface TypeDeclarationCellProps {
  organismeId: number | undefined;
  principal: boolean;
  typeDeclaration: TypeDeclaration;
}